// extracted by mini-css-extract-plugin
export var adjustableWidthBorder = "_54-7";
export var adjustableWidthBorderHeld = "_54-8";
export var arrow = "_54-3";
export var arrowButton = "_54-4";
export var headerCell = "_54-0";
export var help = "_54-2";
export var icon = "_54-1";
export var iconWrapper = "_54-6";
export var noBorder = "_54-b";
export var nonAdjustableWidthBorder = "_54-9";
export var nonAdjustableWidthBorderHeld = "_54-a";
export var textButton = "_54-5";